import * as Consts from "../../../../config";

export default [
  {
    title: "Accounts",
    key: "accounts",
    url: "/accounts",
    icon: "icon fa fa-money",
    roles: Consts.UserPermissions.Admin
  },
  {
    title: "Home",
    key: "dashboard",
    url: "/dashboard",
    icon: "icon icon-home",
    roles: Consts.UserPermissions.All
  },
  {
    title: "Patients",
    key: "patients",
    url: "/patients",
    icon: "icon icon-patient",
    roles: Consts.UserPermissions.AllExcludeSuper
  },
  {
    title: "Conditions",
    key: "conditions",
    url: "/conditions",
    icon: "icon icon-condition",
    roles: Consts.UserPermissions.Internal
  },
  {
    title: "Flows",
    key: "programs",
    url: "/programs",
    icon: "icon icon-flow",
    roles: Consts.UserPermissions.Internal
  },
  {
    title: "Items",
    key: "tasks",
    url: "/tasks",
    icon: "icon icon-task-tick",
    roles: Consts.UserPermissions.Internal
  },
  {
    title: "Media Library",
    key: "library",
    url: "/library",
    icon: "icon icon-media",
    roles: Consts.UserPermissions.Internal
  },
  {
    title: "Inbox",
    key: "inbox",
    url: "/inbox",
    icon: "icon icon-inbox",
    roles: Consts.UserPermissions.AllExcludeSuper
  },

  {
    title: "Treatment Code",
    key: "treatment_codes",
    url: "/treatment_codes",
    icon: "icon icon-patient",
    roles: Consts.UserPermissions.OnlyClinician
  }
];



// WEBPACK FOOTER //
// ./src/components/LayoutComponents/Menu/MenuLeft/menuData.js